/**
 * Thor.js
 * The Thor Hero class
 */

import { Game } from "pixi_core";
import { Hero } from "./Hero";
import { BubbleColor, GameEvents } from "../Constants";

export class Thor extends Hero {
    /**
     * @public
     * @param {Object} heroData
     */
    constructor(heroData) {
        super(heroData);
    }

    /**
     * @public
     * @override
     */
    useAbility() {
        super.useAbility();
        Game.fire(GameEvents.eCANNON_ABILITY_CHANGE_BUBBLE, BubbleColor.eLIGHTNING);
    }
}
